import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { city, country,province } from "../utils/redux/slices/addressSlice";

const useAddressHook = () => {
  const [countryOption, setCountryOption] = useState([]);
  const [provinceOption, setProvinceOption] = useState([]);
  const [cityOption, setCityOption] = useState([]);

  const dispatch = useDispatch();
  const address = useSelector((state) => state?.address);

  useEffect(() => {
    if (address?.country?.data?.length > 0) {
      const sortedCountries = [...address.country.data];
      sortedCountries.sort((a, b) =>
        a?.country_name.localeCompare(b?.country_name)
      );
      setCountryOption(sortedCountries);
    }

    if (address?.province?.data?.length > 0) {
      setProvinceOption(address?.province?.data);
    }

    if (address?.city?.data?.length > 0) {
      setCityOption(address?.city?.data);
    }
  }, [address]);

  useEffect(() => {
    if (address.country === null) {
      dispatch(country());
    }
  }, []);

  const onSelectCountry = (country) => {
    dispatch(province({ country: country }));
  };

  const onSelectProvince = (country, province) => {
    console.log("test new api onSelectProvince",country)
    console.log("test new api onSelectProvince",province)
    dispatch(city({ country: country , province:province}));
  };

  return {
    countryOption,
    cityOption,
    provinceOption,
    onSelectProvince,
    onSelectCountry,
  };
};

export default useAddressHook;
